import * as React from 'react';

import iconUrl from './index.svg';

interface IPriceHistoryUpIcon {
  className?: string;
}

export function PriceHistoryUpIcon(props: IPriceHistoryUpIcon) {
  const className = props.className || '';

  return <img className={className} width="11" height="14" src={iconUrl} alt="" />;
}
